import React from 'react';
import '../LandingPage/LandingPage.css';
import Footer from '../../Components/Footer/FooterSmall';
import header from '../../Components/Header/Header.module.css';
import Header from '../../Components/Header2/Header2';
import sent from './Sent.module.css'


const Sent: React.FC = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth' // Optional: Adds a smooth scrolling animation
  });
  return (
    <div className='generalPage'>
      <div className='landingPage'>
          <Header />
        <div className={sent.sentBody}>
            <h2>
                Your message has been sent.
            </h2>
            <h2>
                Thank you for contacting IceGems!
            </h2>
        </div>
      </div>
      <Footer />
      
    </div>

  );
};

export default Sent;